export type Look = 'classic' | 'diorama';

export function currentLook(): Look {
  if (typeof location === 'undefined') return 'classic';
  return new URLSearchParams(location.search).get('look') === 'classic' ? 'classic' : 'diorama';
}

export function spriteDirectory(look: Look): string {
  return look === 'diorama' ? 'sprites-diorama' : 'sprites';
}
